import { IconProps } from './type';

export const ICBilling: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="16" y="32" width="96" height="64" rx="12" fill="#4f4b5c" />
            <rect x="16" y="46" width="96" height="14" fill="#374151" />
            <rect x="30" y="70" width="20" height="16" rx="3" fill="#a797ff" />
            <rect x="58" y="72" width="42" height="6" rx="3" fill="white" />
            <rect x="58" y="83" width="28" height="6" rx="3" fill="white" />
        </svg>
    );
};
